// Guest accounts are created by the backend with a generated email like
// guest_<timestamp>_<random>@moneysmart.app — that email is the only marker.
export function isGuestUser(user) {
  const email = user?.email || '';
  return email.startsWith('guest_') && email.endsWith('@moneysmart.app');
}

export default isGuestUser;
